import i18nFactory from '@yandex-int/i18n';

import { ValidationErrorData } from '../../typings/common';
import { ConstRelevantPhrasesData } from '../../typings/constants';
import { AdditionalGoalIds, Goal } from '../../typings/goals';
import { RelevantPhrasesState } from '../../typings/relevantPhrases';

import * as keyset from './RelevantPhrasesHelpers.i18n';

const i18n = i18nFactory(keyset);

export interface RelevantPhrasesValidationData {
    isValid: boolean;
    errors: RelevantPhrasesErrors;
}

export interface RelevantPhrasesErrors {
    limit: ValidationErrorData[];
    goal: ValidationErrorData[];
}

export const validateRelevantPhrasesEditor = (
    relevantPhrasesEditorData: RelevantPhrasesState,
    relevantPhrasesConstants: ConstRelevantPhrasesData,
    goals: Record<string, Goal>
): RelevantPhrasesErrors => {
    return {
        limit: validateLimit(
            relevantPhrasesConstants,
            Number(relevantPhrasesEditorData.limit)
        ),
        goal: validateGoal(relevantPhrasesEditorData.goalId, goals)
    };
};

const validateLimit = (
    relevantPhrasesConstants: ConstRelevantPhrasesData,
    limit?: number
): ValidationErrorData[] => {
    const errors = [];
    const { minLimit, maxLimit } = relevantPhrasesConstants;

    if (limit === undefined) {
        errors.push({
            code: 'LIMIT_NOT_SET',
            text: i18n('limit-must-be-set', { minLimit, maxLimit })
        });
    } else if (limit < minLimit) {
        errors.push({
            code: 'LESS_THEN_MIN_LIMIT',
            text: i18n('less-then-min-limit', { minLimit })
        });
    } else if (limit > maxLimit) {
        errors.push({
            code: 'MORE_THEN_MAX_LIMIT',
            text: i18n('more-then-max-limit', { maxLimit })
        });
    }

    return errors;
};

const validateGoal = (
    goalId: string,
    goals: Record<string, Goal>
): ValidationErrorData[] => {
    const errors = [];

    if (
        goalId !== AdditionalGoalIds.notSet &&
        goalId !== AdditionalGoalIds.all &&
        goals[goalId] === undefined
    ) {
        errors.push({
            code: 'UNAVAILABLE_GOAL',
            text: i18n('unavailable-goal')
        });
    }

    return errors;
};
